import React from "react";
import "../styles/About.css";
import { FaCheckCircle } from "react-icons/fa";

const About: React.FC = () => {
  return (
    <div className="about-container">
      <div className="breadcrumb">ANASAYFA / HAKKIMIZDA</div>
      {/* <h1 className="about-title">Hakkımızda</h1> */}
      <img src={require("../assets/images/log3.png")} alt="Logo" className="about-logo enlarged-logo" />

      <p className="about-text">
        <FaCheckCircle className="icon" /> Firmamız, ziynet ürünleri, has altın, gümüş ve gram altın toptan alış satışında güvenilir ve güçlü bir iş ortağı olarak sektörde hizmet vermektedir. Uzun yıllara dayanan tecrübemizle, değerli madenler alanında kaliteli ve rekabetçi çözümler sunuyoruz.
      </p>

      <p className="about-text">
        <FaCheckCircle className="icon" /> Müşterilerimize sunduğumuz geniş ürün yelpazesi ve hızlı tedarik süreçlerimizle, piyasa ihtiyaçlarına en uygun ürünleri sağlamaktayız. Sektördeki gelişmeleri yakından takip eden profesyonel ekibimizle, müşterilerimize avantajlı fiyatlar sunarak iş ortaklarımızın taleplerini en yüksek standartlarda karşılamaya özen gösteriyoruz.
      </p>

      <p className="about-text">
        <FaCheckCircle className="icon" /> Güvenilirlik ve sürdürülebilirlik prensipleriyle çalışarak, toptan ziynet ve değerli maden alış satışında sektörde lider bir konumda yer almayı hedefliyoruz. Müşterilerimizle uzun vadeli ve sağlam iş ilişkileri kurarak, sektörde güvenilir bir tedarikçi olarak hizmet sunmaya devam ediyoruz.
      </p>
    </div>
  );
};

export default About;
